Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.ReviewCommentFactory

  create: (socialContent, allTags) ->
    content = new Monitoring.Models.SocialContents.AnalysisUnitFactory().create(socialContent, allTags)
    content.set({ possibleTags: allTags })
    return content

  canHandle: (socialContent) ->
    return socialContent.group_type == 'google_play'